import { unsafeCoerce } from 'effect';
import * as S from '@effect/schema/Schema';
const uri = Symbol('ProductId');
export const ProductId = S.String.pipe(S.brand(uri));
export const unsafeCoerceToProductId = (x) => unsafeCoerce(x);
